// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"204":"route-travel","344":"route-travelLocation"}[chunkId] + ".chunk." + {"204":"b7989","344":"adf93"}[chunkId] + ".css";
};